// import React from 'react';
// import { 
//   ClipboardCheck, ShieldAlert, Gavel, Scale, 
//   Coins, FileCheck, Landmark, Ban, 
//   ArrowLeft, CheckCircle2, History 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function ExecutionServices() {
  
//   // Executive instruments/bonds the firm enforces
//   const executiveBonds = [
//     {
//       title: "السندات لأمر والشيكات",
//       desc: "تحصيل الأوراق التجارية وتحرير محاضر التنفيذ ضد المدينين، وتفعيل أوامر القبض والمنع من السفر إلكترونياً.",
//       icon: <Coins className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "الأحكام القضائية القطعية",
//       desc: "تنفيذ الأحكام الصادرة من المحاكم العامة، التجارية، العمالية، والإدارية، وتحويلها إلى واقع مالي ملموس.",
//       icon: <Gavel className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "أحكام المحكمين ومحاضر الصلح",
//       desc: "إكساب أحكام التحكيم المحلية والدولية صيغة التنفيذ، وتنفيذ محاضر الصلح الموثقة عبر منصات وزارة العدل.",
//       icon: <FileCheck className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "العقود والقرارات الموثقة",
//       desc: "تنفيذ عقود الإيجار الموحدة، عقود التمويل، والقرارات الصادرة من اللجان شبه القضائية ذات القوة التنفيذية المباشرة.",
//       icon: <Landmark className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="قيد السندات التنفيذية ومتابعة التنفيذ"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1450133064473-71024230f91b?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">قضاء التنفيذ: القوة الجبرية للنظام</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">قيد السندات التنفيذية ومتابعة التنفيذ</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             الحكم بلا تنفيذ هو حبر على ورق. نحن نضع القوة الإجرائية لنظام التنفيذ السعودي في خدمة حقوقك، عبر ملاحقة أموال المدينين، تتبع أصولهم، وتطبيق التدابير القضائية الصارمة لاسترداد أموالك بسرعة.
//           </p>
//         </div>
//       </section>

//       {/* Main Analytical Framework */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6 leading-tight">
//               سرعة التحرك الإجرائي هي مفتاح تحصيل ديونك
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               يعطي نظام التنفيذ في المملكة العربية السعودية قاضي التنفيذ صلاحيات واسعة لفرض سلطة القانون. يرتكز عملنا على استثمار هذه الصلاحيات فوراً دون إتاحة أي فرصة للمماطلة أو تهريب الأصول من قِبل المدين.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               نحن نتولى إدارة ملف التنفيذ بالكامل عبر منصة ناجز الرقمية، بدءاً من تقديم الطلب مستوفياً الشروط، ومتابعة إصدار قرار المادة (34) للإبلاغ، وصولاً لتفعيل المادة (46) التي تشمل الحجز على الحسابات البنكية، والمنع من السفر، وإيقاف الخدمات التشغيلية والتجارية للمدين.
//             </p>
//           </div>
          
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 space-y-4 shadow-lg">
//             <h3 className="font-bold text-amber-500 text-base flex items-center gap-2">
//               <Ban className="w-5 h-5" /> تدابير المادة (46) الحازمة:
//             </h3>
//             <ul className="space-y-3 text-xs text-slate-300">
//               <li className="flex items-center gap-2">
//                 <CheckCircle2 className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>إيقاف الخدمات الحكومية والمالية للمدين.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle2 className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>الحجز التلقائي على الأرصدة المصرفية والأسهم.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle2 className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>منع السفر وإدراج اسم المدين بمركز معلومات المستثمرين.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle2 className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>الإفصاح عن الأصول العقارية والممتلكات وتصفيتها.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Grid: What instruments do we enforce */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">السندات ذات القوة التنفيذية الجبرية</h2>
//           <p className="text-gray-500">نتولى ملاحقة وتنفيذ كافة المحررات التي أسبغ عليها المنظم السعودي صفة النفاذ المباشر</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {executiveBonds.map((bond, index) => (
//             <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 hover:border-amber-500 hover:shadow-md transition-all duration-300">
//               <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
//                 {bond.icon}
//               </div>
//               <h3 className="text-xl font-bold text-slate-800 mb-2">{bond.title}</h3>
//               <p className="text-gray-500 text-sm leading-relaxed">{bond.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Process Pipeline Section */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">مسار التنفيذ القضائي الذكي</h2>
//             <p className="text-slate-400">مراحل وخطوات إجرائية دقيقة نتابعها لضمان استرجاع الحقوق المالية بأسرع وقت</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            
//             {/* Step 1 */}
//             <div className="bg-slate-800/40 p-6 rounded-xl border border-slate-700">
//               <span className="text-amber-500 font-bold block mb-1 text-sm">خطوة ٠١</span>
//               <h3 className="text-lg font-bold mb-2">الدراسة وقيد الطلب</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">التأكد من سلامة السند التنفيذي شكلاً ومضموناً، وخلوه من عيوب التقادم، ثم قيده رسمياً عبر بوابة ناجز وتوجيهه للمحكمة المختصة.</p>
//             </div>

//             {/* Step 2 */}
//             <div className="bg-slate-800/40 p-6 rounded-xl border border-slate-700">
//               <span className="text-amber-500 font-bold block mb-1 text-sm">خطوة ٠٢</span>
//               <h3 className="text-lg font-bold mb-2">تفعيل أوامر الحجز والمنع</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">بعد انتهاء مهلة مادة (34)، نتقدم بطلب فوري لتطبيق عقوبات مادة (46) للحجز على حسابات المدين المصرفية ومخاطبة البنك المركزي السعودي (SAMA).</p>
//             </div>

//             {/* Step 3 */}
//             <div className="bg-slate-800/40 p-6 rounded-xl border border-slate-700">
//               <span className="text-amber-500 font-bold block mb-1 text-sm">خطوة ٠٣</span>
//               <h3 className="text-lg font-bold mb-2">الإفراز والتحصيل المالي</h3>
//               <p className="text-slate-400 text-xs leading-relaxed">متابعة محاضر الإفصاح عن العقارات والسيارات والممتلكات، والإشراف على تحويل المبالغ المحجوزة لحساب المحكمة ثم قيدها في حساب العميل.</p>
//             </div>

//           </div>
//         </div>
//       </section>

//       {/* Defensive/Offensive Warning Banner */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <ShieldAlert className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">حماية وقائية ضد منازعات التنفيذ:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               إذا كنت مديناً وصدر ضدك طلب تنفيذ غير نظامي، أو كنت دائناً وتواجه مماطلة عبر تقديم المدين (منازعة تنفيذ) صورية لتعطيل الإجراءات؛ فإن فريقنا يمتلك المهارة القضائية لتقديم مذكرات الرد على منازعات التنفيذ وإثبات كيديتها أمام الدائرة القضائية لعدم رفع الحجز أو تعطيل مصالحك.
//             </p>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }


import React from 'react';
import { 
  ClipboardCheck, ShieldAlert, Gavel, Scale, 
  Coins, FileCheck, Landmark, Ban, 
  ArrowLeft, CheckCircle2, History 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function ExecutionServices() {
  
  // Executive instruments/bonds the firm enforces - Refactored to Navy Light
  const executiveBonds = [
    {
      title: "السندات لأمر والشيكات",
      desc: "تحصيل الأوراق التجارية وتحرير محاضر التنفيذ ضد المدينين، وتفعيل أوامر القبض والمنع من السفر إلكترونياً.",
      icon: <Coins className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "الأحكام القضائية القطعية",
      desc: "تنفيذ الأحكام الصادرة من المحاكم العامة، التجارية، العمالية، والإدارية، وتحويلها إلى واقع مالي ملموس.",
      icon: <Gavel className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "أحكام المحكمين ومحاضر الصلح",
      desc: "إكساب أحكام التحكيم المحلية والدولية صيغة التنفيذ، وتنفيذ محاضر الصلح الموثقة عبر منصات وزارة العدل.",
      icon: <FileCheck className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "العقود والقرارات الموثقة",
      desc: "تنفيذ عقود الإيجار الموحدة، عقود التمويل، والقرارات الصادرة من اللجان شبه القضائية ذات القوة التنفيذية المباشرة.",
      icon: <Landmark className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="قيد السندات التنفيذية ومتابعة التنفيذ"
        description="نضع القوة الإجرائية لنظام التنفيذ السعودي في خدمة حقوقك لاسترداد أموالك بكفاءة"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1450133064473-71024230f91b?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for modern executive contrast */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">قضاء التنفيذ: القوة الجبرية للنظام</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">قيد السندات التنفيذية ومتابعة التنفيذ</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            الحكم بلا تنفيذ هو حبر على ورق. نحن نضع القوة الإجرائية لنظام التنفيذ السعودي في خدمة حقوقك، عبر ملاحقة أموال المدينين، تتبع أصولهم، وتطبيق التدابير القضائية الصارمة لاسترداد أموالك بسرعة.
          </p>
        </div>
      </section>

      {/* Main Analytical Framework */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col lg:flex-row gap-12 items-center">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-extrabold text-indigo-950 mb-6 leading-tight">
              سرعة التحرك الإجرائي هي مفتاح تحصيل ديونك
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              يعطي نظام التنفيذ في المملكة العربية السعودية قاضي التنفيذ صلاحيات واسعة لفرض سلطة القانون. يرتكز عملنا على استثمار هذه الصلاحيات فوراً دون إتاحة أي فرصة للمماطلة أو تهريب الأصول من قِبل المدين.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              نحن نتولى إدارة ملف التنفيذ بالكامل عبر منصة ناجز الرقمية، بدءاً من تقديم الطلب مستوفياً الشروط، ومتابعة إصدار قرار المادة (34) للإبلاغ، وصولاً لتفعيل المادة (46) التي تشمل الحجز على الحسابات البنكية، والمنع من السفر، وإيقاف الخدمات التشغيلية والتجارية للمدين.
            </p>
          </div>
          
          {/* Executive Sidebar - Refactored to Navy Light */}
          <div className="w-full lg:w-80 bg-slate-50 text-indigo-950 p-6 rounded-xl border border-slate-200/60 space-y-4 shadow-sm shrink-0">
            <h3 className="font-bold text-indigo-950 text-base flex items-center gap-2">
              <Ban className="w-5 h-5 text-blue-700" /> تدابير المادة (46) الحازمة:
            </h3>
            <ul className="space-y-3 text-xs text-slate-600 font-light">
              <li className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-indigo-950 shrink-0" />
                <span>إيقاف الخدمات الحكومية والمالية للمدين.</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-indigo-950 shrink-0" />
                <span>الحجز التلقائي على الأرصدة المصرفية والأسهم.</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-indigo-950 shrink-0" />
                <span>منع السفر وإدراج اسم المدين بمركز معلومات المستثمرين.</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-indigo-950 shrink-0" />
                <span>الإفصاح عن الأصول العقارية والممتلكات وتصفيتها.</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Grid: What instruments do we enforce - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">السندات ذات القوة التنفيذية الجبرية</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">نتولى ملاحقة وتنفيذ كافة المحررات التي أسبغ عليها المنظم السعودي صفة النفاذ المباشر</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {executiveBonds.map((bond, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit text-slate-700 mb-4">
                  {bond.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{bond.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{bond.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Pipeline Section - Converted completely to Premium Light Grid */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">مسار التنفيذ القضائي الذكي</h2>
          <p className="text-slate-500 text-sm md:text-base font-light">مراحل وخطوات إجرائية دقيقة نتابعها لضمان استرجاع الحقوق المالية بأسرع وقت</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          
          {/* Step 1 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <span className="text-blue-700 font-bold block mb-1 text-xs uppercase tracking-wider">خطوة ٠١</span>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">الدراسة وقيد الطلب</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">التأكد من سلامة السند التنفيذي شكلاً ومضموناً، وخلوه من عيوب التقادم، ثم قيده رسمياً عبر بوابة ناجز وتوجيهه للمحكمة المختصة.</p>
          </div>

          {/* Step 2 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <span className="text-blue-700 font-bold block mb-1 text-xs uppercase tracking-wider">خطوة ٠٢</span>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">تفعيل أوامر الحجز والمنع</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">بعد انتهاء مهلة مادة (34)، نتقدم بطلب فوري لتطبيق عقوبات مادة (46) للحجز على حسابات المدين المصرفية ومخاطبة البنك المركزي السعودي (SAMA).</p>
          </div>

          {/* Step 3 */}
          <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm relative hover:shadow-md transition-shadow duration-200">
            <span className="text-blue-700 font-bold block mb-1 text-xs uppercase tracking-wider">خطوة ٠٣</span>
            <h3 className="text-lg font-bold text-indigo-950 mb-2">الإفراز والتحصيل المالي</h3>
            <p className="text-slate-500 text-xs leading-relaxed font-light">متابعة محاضر الإفصاح عن العقارات والسيارات والممتلكات، والإشراف على تحويل المبالغ المحجوزة لحساب المحكمة ثم قيدها في حساب العميل.</p>
          </div>

        </div>
      </section>

      {/* Defensive/Offensive Warning Banner - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto pb-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <ShieldAlert className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">حماية وقائية ضد منازعات التنفيذ:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              إذا كنت مديناً وصدر ضدك طلب تنفيذ غير نظامي، أو كنت دائناً وتواجه مماطلة عبر تقديم المدين (منازعة تنفيذ) صورية لتعطيل الإجراءات؛ فإن فريقنا يمتلك المهارة القضائية لتقديم مذكرات الرد على منازعات التنفيذ وإثبات كيديتها أمام الدائرة القضائية لعدم رفع الحجز أو تعطيل مصالحك.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}